export const EXPERIMENTAL = false;
export const EXPERIMENTAL_OWNER = 'Sam Kowalski';
export const EXPERIMENTAL_OWNED_SINCE = 'Owner since 2019 · Yonkers, NY';
